//https://dev.to/danawoodman/svelte-quick-tip-connect-a-store-to-local-storage-4idi
//https://akashmittal.com/initialize-store-localstorage-svelte/
//https://natclark.com/tutorials/svelte-sync-localstorage-with-store/
//https://chasingcode.dev/blog/svelte-persist-state-to-localstorage/
//https://peterbabic.dev/blog/store-array-svelte-localstorage/

import { writable, readable } from 'svelte/store';

//theme settings
export const app_themes = readable(['Dark','Light','CRT','Disco']);

const storedTheme = localStorage.getItem("app_theme");
export const app_theme = writable(parseInt(storedTheme));
app_theme.subscribe(value => localStorage.setItem("app_theme", String(value)));
    
//export const app_theme = writable(0);
// Anytime the store changes, update the local storage value.
//export const app_theme = writable(parseInt(localStorage.getItem('app_theme')) || 0);
//app_theme.subscribe((value) => localStorage.setItem('app_theme', String(value)));


//cpu settings
export const cpu_speed = writable(25);
export const max_speed = writable(40);
export const min_speed = writable(1);

//sound settings
export const play_sound = writable(true);
//export const play_sound = writable<Boolean>(localStorage.getItem('play_sound') === 'true');
play_sound.subscribe((value) => localStorage.setItem("play_sound", Boolean(value)));








//num solved
export const num_solved = writable(0);


//game finished
export const game_over = writable(false);
//export const play_sound = writable<Boolean>(localStorage.getItem('play_sound') === 'true');
game_over.subscribe((value) => localStorage.setItem("game_over", Boolean(value)));

export const first_time = writable(true);
//export const play_sound = writable<Boolean>(localStorage.getItem('play_sound') === 'true');
first_time.subscribe((value) => localStorage.setItem("first_time", Boolean(value)));   
    

export const play_ending = writable(true);
//export const play_sound = writable<Boolean>(localStorage.getItem('play_sound') === 'true');
play_ending.subscribe((value) => localStorage.setItem("play_ending", Boolean(value)));   
    
    
//level settings
const storedLevels = localStorage.getItem("user_levels");
//alert(storedLevels);
const level1 = {'1':{ 'id': 1, 'program': '', 'solved':false, 'available':true,'cycles':9999,'io':9999,'cmds':9999}};
const parsedlevs = (storedLevels == undefined ? level1 : JSON.parse(storedLevels));
//if(
export const user_levels = writable(parsedlevs);//(parsedlevs != null) ? parsedlevs : level1);

user_levels.subscribe(value => localStorage.setItem("user_levels", JSON.stringify(value)));

//export const user_levels = writable({
//	    '1':{ 
//	     id: 1,
//	     program: '## PROG 1 ##',
//	     solved:false,
//	     available:true
//	    }
//	});
